import Vue from 'vue'
import VueI18n from 'vue-i18n'

import es from './translations/es.yml'
import en from './translations/en.yml'

// const debug = require('debug')('OD::i18n')

Vue.use(VueI18n)

function getLocale() {
  const storeLang = localStorage.getItem('lang')
  const browserLang = navigator.language || navigator.userLanguage
  let locale = null
  if (storeLang) {
    locale = storeLang
  } else {
    if (browserLang) {
      if (browserLang.indexOf('es') >= 0) locale = 'es'
      if (browserLang.indexOf('en') >= 0) locale = 'en'
    }
    if (!locale) {
      locale = 'en'
    }
  }
  return locale
}

const locale = getLocale()
const messages = {
  es: es,
  en: en,
}
const i18n = new VueI18n({
  locale,
  messages,
})

Object.defineProperty(Vue.prototype, '$locale', {
  get: function() {
    return i18n.locale
  },
  set: function(locale) {
    localStorage.setItem('lang', locale)
    i18n.locale = locale
  },
})

export default i18n
